export type FeatureFlags =
  | AllFeatureFlags
  | HomeSinisterUrgentQuestionsFeatureFlags
  | PoliciesListFlags
  | SearcherFlags;

export enum AllFeatureFlags {
  SAVING_LIFE_ADVICES = 'savingLifeAdvices',
  DOCUMENT_CAPTURE = 'documentCapture',
  AVAILABLE_EDIT_PROFILE = 'availableEditProfile',
  COPAYMENT_CARDS = 'copaymentCards',
  SINISTER_CONSULTATION = 'sinisterConsultation',
  SINISTER_CONSULTATION_COMPANIES = 'sinisterConsultationCompanies',
  SIGNING_KEY = 'signingKey',
  GENERAL_CONDITIONS = 'generalConditions',
  ACI_COMPANIES_ENABLED = 'aciCompaniesEnabled',
  SUPERBONUS = 'superbonus',
  RECEIPT_PAYMENT = 'receiptPayment',
  FAMILIES = 'families',
  SINISTER_WITHOUT_CONTRARY = 'sinistersWithoutContrary',
  AVAILABLE_APP_RATING = 'availableAppRating',
  PWA_ACCESS_BLOCKED = 'pwaAccessBlocked',
  SHOW_USER_AUTO_SINISTER_COMMUNICATIONS = 'showUserAutoSinisterCommunications',
  NEW_MEDICAL_CENTERS_ENDPOINT = 'newMedicalCentersEndpoint',
  PENSION_PLAN_VALUATION = 'pensionPlanValuation',
  HELP_INBOX = 'helpInbox',
  BANK_DATA_MANAGMENT = 'bankDataManagement',
  CARD_DUPLICATE_REQUEST = 'cardDuplicateRequest',
  PAYMENT_PLAN_CONTRACT = 'paymentPlanContract',
  ACCESS_COMPANIES_LOGIN = 'accessCompaniesLogin',
  ACCESS_PARTICULARS_LOGIN = 'accessParticularsLogin',
  NETWORK_CONSULTATION = 'userNetworkConsultation',
  MULTIMAP = 'multiMap',
  GUIDED_LOGIN = 'guidedLogin',
  TECUIDAMOS_SAVIA = 'teCuidamosSavia',
  TECUIDAMOS_LOYALIA = 'teCuidamosLoyalia',
  YCAR_ECO_ACTIVITY = 'ycarEcoActivity',
  DOWNLOAD_CONTRACT = 'downloadContract',
  CONTACT_FORM = 'contactForm',
  SUPPORT_FORM = 'supportForm',
  RGPDUE_POLICY_ACCEPTANCE = 'rgpduePolicyAcceptance',
  SDK_OPINATOR = 'sdkOpinator',
  HEALTH_REFUNDS = 'healthRefunds',
  HEALTH_AUTHORIZATIONS = 'healthAuthorizations',
  BUSINESS_LINKAGE_DISCOUNT = 'businessLinkageDiscount',
  EMBEDDING_APP_SALUD = 'embeddingAppSalud',
  CROSSELLING_RECOMMENDATIONS = 'crossellingRecommendations',
  DEREGISTER_USER = 'deregisterUser',
  VEHICLE_ACCIDENTS_DRAFT_RECOVERY = 'vehicleAccidentsDraftRecovery',
  ROAD_ASSISTANCE_APP = 'roadAssistanceAPP',
  ROAD_ASSISTANCE_WEB = 'roadAssistanceWEB',
  ZENDESK_CHAT_APP = 'zendeskChatApp',
  ZENDESK_CHAT_WEB = 'zendeskChatWeb',
  ZENDESK_CHAT_RESPONSIVE = 'zendeskChatResponsive',
  GENESYS_CHAT = 'genesysChat',
  REQUEST_DEFAULT_NOTIFICATIONS_PREFERENCE = 'requestDefaultNotificationPreference',
  EMBEDDED_APP_AFIN = 'embeddingAppAFIN',
  PAYMENT_PLAN_COMPANIES = 'paymentPlanCompanies'
}

export enum SearcherFlags {
  SEARCH_OFFICES_NEW_ENDPOINT = 'newOfficesEndpoint',
  SEARCH_COLLABORATORS_NEW_ENDPOINT = 'newCollaboratorsEndpoint',
  SEARCH_WORKSHOPS_NEW_ENDPOINT = 'newWorkshopsEndpoint',
  SEARCH_MEDICAL_CENTERS_NEW_ENDPOINT = 'newMedicalCentersEndpoint'
}

export enum PoliciesListFlags {
  POLICY_CAR = 'policiesList__car',
  POLICY_HOME = 'policiesList__home',
  POLICY_LIFE = 'policiesList__life',
  POLICY_COLLECTIVE_LIFE = 'policiesList__collective-life',
  POLICY_SAVING = 'policiesList__saving',
  POLICY_HEALTH = 'policiesList__health',
  POLICY_PENSION = 'policiesList__pension',
  POLICY_INVESTMENT = 'policiesList__investment',
  POLICY_NOVA_INVESTMENT = 'policiesList__investment-nova',
  POLICY_OTHER = 'policiesList__other',
  POLICY_ACCIDENT = 'policiesList__accident',
  POLICY_DEATH = 'policiesList__death'
}

export enum HomeSinisterUrgentQuestionsFeatureFlags {
  PATRIMONIAL_URGENT_QUESTIONS_THEFTATTEMPT = 'urgentClaimQuestionsTheftAttempt',
  PATRIMONIAL_URGENT_QUESTIONS_WATERDAMAGE = 'urgentClaimQuestionsWaterDamage',
  PATRIMONIAL_URGENT_QUESTIONS_LOSTKEYS = 'urgentClaimQuestionsLostKeys',
  PATRIMONIAL_URGENT_QUESTIONS_ELECTRICALDAMAGE = 'urgentClaimQuestionsElectricalDamage',
  PATRIMONIAL_URGENT_QUESTIONS_BREAKS = 'urgentClaimQuestionsBreaks',
  PATRIMONIAL_URGENT_QUESTIONS_THEFT = 'urgentClaimQuestionsTheft'
}

export const mmobileCardsTranslations = {
  car: 'tarjetaAutos',
  home: 'tarjetaHogar',
  life: 'tarjetaVidaRiesgo',
  saving: 'tarjetaVidaAhorro',
  health: 'tarjetaSalud',
  pension: 'tarjetaPlanesPensiones',
  investment: 'tarjetaCarterasInversion',
  'investment-nova': 'tarjetaCarterasInversion',
  'collective-life': 'tarjetaColectivosVida',
  other: 'tarjetaOtros',
  accident: 'tarjetaAccidentes',
  death: 'tarjetaDecesos'
};

export enum CustomConfigKeys {
  CARDS = 'tarjetas'
}

export enum CardConfigFlags {
  VEHICLE_CHANGE =  'vehicleChangeEnabled',
  METHOD_PAYMENT =  'methodPaymentChangeEnabled',
  PRODUCT_CHANGE =  'productChangeEnabled',
  ACTIVE_DEACTIVE_ADDITIONAL_COVERAGES = 'activateDeactivateCoveragesEnabled'
}
